import { useCallback } from "react";
import { useActivateService, useServices } from "@/hooks/useApi";

export function useLlmServices() {
  const {
    data: services,
    isLoading: loading,
    error,
    refetch,
  } = useServices({ kind: "llm" });
  const { mutateAsync: activateService, isPending: isActivating } =
    useActivateService();

  const llmServices = services ?? [];
  const activeLlm = llmServices.find((s) => s.is_active) ?? null;

  const activateLlm = useCallback(
    async (name: string) => {
      try {
        await activateService(name);
        refetch();
      } catch {
        // Activation failed — isActivating resets via hook state.
      }
    },
    [activateService, refetch],
  );

  return { llmServices, activeLlm, activateLlm, isActivating, loading, error };
}
